import { FormattedMessage } from 'react-intl';
import IdentityVerificationPath from '@repo/visual-assets/illustrations/ill-cp-account-identity-verification.svg';
import { StatusScreen } from '#components/status-screen/status-screen';
import { useTrackRender } from '@repo/shared-kit/hooks/use-track-render';
import { ExternalLink } from '@repo/design-system-kit/components/external-link/external-link';
import { InternalLink } from '@repo/shared-kit/components/internal-link/internal-link';
import { useHomePage } from '@repo/shared-kit/home-page/home-page';
import { isExternalUrl } from '@repo/shared-kit/braze/content-card/is-external-url';

export interface WaitingResultsProps {
  provider?: string | null;
  redirectUrl: string | null;
  origin: string | null;
}

export function WaitingResults({ provider, redirectUrl, origin }: WaitingResultsProps) {
  const homePage = useHomePage();

  useTrackRender({
    eventName: 'kyc_waiting_results_screen_loaded',
    params: {
      origin,
    },
  });

  return (
    <StatusScreen
      title={
        <FormattedMessage
          defaultMessage="We're verifying your identity"
          id="identity-verification-kit.waiting-results.title"
        />
      }
      subtitle={
        <FormattedMessage
          defaultMessage="Our partner {provider, select, fourthline {Fourthline} idnow {Idnow} other {} } is currently performing some regulatory checks for your identity verification. We'll get back to you via email within 24 hours."
          id="identity-verification-kit.waiting-results.subtitle"
          values={{
            provider: provider ?? '',
          }}
        />
      }
      illustration={<img alt="" src={IdentityVerificationPath} />}
      cta={
        redirectUrl && isExternalUrl(redirectUrl) ? (
          <ExternalLink display="button" href={redirectUrl}>
            <FormattedMessage
              defaultMessage="Go to Qonto app"
              id="identity-verification-kit.waiting-results.cta"
            />
          </ExternalLink>
        ) : (
          <InternalLink display="button" to={redirectUrl ?? homePage.defaultRouteAbsolutePath}>
            <FormattedMessage
              defaultMessage="Go to Qonto app"
              id="identity-verification-kit.waiting-results.cta"
            />
          </InternalLink>
        )
      }
    />
  );
}
